import { useLanguage } from '../../i18n/LanguageContext';

interface KpiData {
  pendingOrders: number;
  activeOrders: number;
  totalOrders: number;
  completedOrders: number;
  totalRevenue: number;
}

interface KpiCardsProps {
  kpi: KpiData;
}

function KpiCards({ kpi }: KpiCardsProps) {
  const { t } = useLanguage();

  const cards = [
    {
      label: t('dashboard.kpi.pendingOrders'),
      value: kpi.pendingOrders,
      iconClass: 'pending',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6v6l4 2" />
        </svg>
      ),
    },
    {
      label: t('dashboard.kpi.activeOrders'),
      value: kpi.activeOrders,
      iconClass: 'active',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      ),
    },
    {
      label: t('dashboard.kpi.totalOrders'),
      value: kpi.totalOrders,
      iconClass: 'total',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="18" rx="2" />
          <path d="M8 7h8" />
          <path d="M8 11h8" />
          <path d="M8 15h4" />
        </svg>
      ),
    },
    {
      label: t('dashboard.kpi.completedOrders'),
      value: kpi.completedOrders,
      iconClass: 'completed',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 6L9 17l-5-5" />
        </svg>
      ),
    },
    // Total Revenue card intentionally removed (Maher, 2026-08-31): the dashboard
    // revenue figure does not reflect real earnings yet. Order-status KPIs stay.
    // Re-add only once it is sourced from settlement/earnings data.
  ];

  return (
    <div className="partner-kpi-grid">
      {cards.map((card) => (
        <div key={card.label} className="partner-kpi-card">
          <div className={`partner-kpi-icon ${card.iconClass}`}>
            {card.icon}
          </div>
          <div>
            <div className="partner-kpi-value">
              {typeof card.value === 'number' ? card.value : card.value}
            </div>
            <div className="partner-kpi-label">{card.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default KpiCards;
